import { ReactNode } from 'react';
import { SMS } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { AiReasoningAccordion } from './ai-reasoning-accordion';
import { TasksAccordion } from './tasks-accordion';

type Props = {
  subject?: string;
  body?: string;
  outcomeBubble?: ReactNode;
  tasks?: SMS['tasks'];
};

export const MessageInsightsReasoning = ({ subject, body, outcomeBubble, tasks }: Props) => {
  return (
    <div
      css={{
        paddingTop: theme.spacing(2),
        borderTop: `1px solid ${theme.colors.neutral10}`,
      }}
    >
      <Accordion
        variant='main'
        startingValue={'ai-reasoning'}
        css={{
          marginTop: theme.spacing(2),
        }}
      >
        <div
          css={{
            width: '100%',
          }}
        >
          <AiReasoningAccordion subject={subject} body={body} outcomeBubble={outcomeBubble} />
          <TasksAccordion tasks={tasks} />
        </div>
      </Accordion>
    </div>
  );
};
